module.exports = __webpack_public_path__ + "static/img/fct-1.29e9825.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/fct-1.png
// module id = ybuc
// module chunks = 63